module.exports = Object.freeze({
    blockchainAnalyze:{
        COLORS_OF_PLATFORMS: ['#ede107','#62e162','#9a2a9d','#3ea1d9']
    }
})